// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Налаштування пошуку» (Search settings, ключ `srch`, група `settings`). */
export const searchSettingsManifest: IModuleManifest = {
  key: 'srch',
  group: 'settings',
  slug: 'search-settings',
  prefix: 'SRC',
  name: { en: 'Search settings', uk: 'Налаштування пошуку' },
  entities: [
    { key: 'srch', slug: 'srch', name: { en: 'Search scopes', uk: 'Області пошуку' }, main: true },
    { key: 'srchsyn', slug: 'srchsyn', name: { en: 'Synonyms', uk: 'Синоніми' }, main: false },
  ],
  loadState: () => import('./state/searchSettingsSlice').then((m) => m.searchSettingsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
